import { type FC, useState } from 'react';

import { useAppSelector } from '@/redux/store';

import Window from '../AddNewGroupWindow/Window';

import IfNoGroups from './ifNoGroups/IfNoGroups';
import YourGroup from './YourGroup/YourGroup';

interface TabsBodyProps {
  isRequestEnd: boolean;
}

const TabsBody: FC<TabsBodyProps> = ({ isRequestEnd }) => {
  const [newGroupWindow, setNewGroupWindow] = useState(false);

  const groupFriends = useAppSelector((state) => state.groupFriends.group);

  return (
    <>
      {isRequestEnd && (
        <>
          {!groupFriends ? (
            <IfNoGroups setOpen={setNewGroupWindow} />
          ) : (
            <YourGroup setNewGroupWindow={setNewGroupWindow} />
          )}
        </>
      )}
      <Window
        name={groupFriends?.name || ''}
        active={newGroupWindow}
        setOpen={setNewGroupWindow}
      />
    </>
  );
};

export default TabsBody;
